module.exports = __webpack_public_path__ + "static/media/plus2.7a6283ec.svg";